<template>
  <div class="login-layout">
    <loginHeader :title="headerTitle"></loginHeader>
    <loginNecker :data="neckerData"></loginNecker>
    <router-view></router-view>
  </div>
</template>

<script>
import loginHeader from '@/components/base/loginHeader.vue'
import loginNecker from '@/components/base/loginNecker.vue'

export default {
  components: { loginHeader, loginNecker },
  name: 'loginLayout',
  data() {
    return {
      headerTitle: '首页',
      neckerData: []
    }
  },
  watch: {
    '$route.fullPath': {
      handler: function (val, oldVal) {
        let meta = this.$route.meta || {}
        this.headerTitle = meta.title || ''
        this.setNeckerData()
      }
    }
  },
  created() {
    this.setNeckerData()
  },
  methods: {
    setNeckerData() {
      const matched = this.$route.matched || []
      let result = []
      let redirectArr = []
      for (const item of matched) {
        const meta = item.meta || { notNecker: false }
        if (redirectArr.indexOf(item.path) !== -1 || meta.notNecker) {
          continue
        } else {
          result.push({ to: item.redirect || item.path || '/', title: meta.title || '页面' })
        }
        // if (item.path === '/self/login') {
        //   continue
        // } else if (item.path === '/self') {
        //   const meta = item.meta || {}
        //   result.push({ to: '/self/login', title: meta.title || '页面' })
        // } else {
        //   const meta = item.meta || {}
        //   result.push({ to: item.path || '/', title: meta.title || '页面' })
        // }
        if (item.redirect) {
          redirectArr.push(item.redirect)
        }
      }
      this.neckerData = result
    }
  }
}
</script>
<style lang="scss" scoped>
.login-layout {
  width: $width;
  // height: 500px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/loginLayout.vue